import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import useAnalytics from "@/hooks/useAnalytics";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Book from "@/pages/Book";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import TestimonialBIID from "@/pages/TestimonialBIID";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import LegacyBlogRedirect from "@/pages/LegacyBlogRedirect";
import Contact from "@/pages/Contact";
import Appreciation from "@/pages/Appreciation";
import Spiral from "@/pages/Spiral";
import AdminTraffic from "@/pages/AdminTraffic";

import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refund from "@/pages/legal/Refund";
import AgePolicy from "@/pages/legal/AgePolicy";
import Release from "@/pages/legal/Release";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useAnalytics();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <AgeGate />}
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyMobileCTA />}
    </>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen bg-charcoal text-cream pb-20 md:pb-0">
      <BrowserRouter>
        <ScrollToTop />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/book" element={<Book />} />
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/testimonials/biid" element={<TestimonialBIID />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/hypnosex/:file" element={<LegacyBlogRedirect />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/appreciation" element={<Appreciation />} />
            <Route path="/spiral" element={<Spiral />} />
            <Route path="/admin/traffic" element={<AdminTraffic />} />

            <Route path="/legal/terms" element={<Terms />} />
            <Route path="/legal/privacy" element={<Privacy />} />
            <Route path="/legal/refund" element={<Refund />} />
            <Route path="/legal/age" element={<AgePolicy />} />
            <Route path="/legal/release" element={<Release />} />
          </Routes>
        </Chrome>
        <Toaster richColors theme="dark" position="top-center" />
      </BrowserRouter>
    </div>
  );
}
